import React, { useEffect, useState } from "react";
import { profileService } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { Avatar, Button, Card, Input, PhoneInput } from "../../components/ui";

export default function CustomerProfile() {
  const { profile, setProfile, toast } = useApp();
  const { t, tx } = useI18n();
  const [form, setForm] = useState({ fullname: "", phone: "", email: "", address: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (profile) setForm({ fullname: profile.fullname || "", phone: profile.phone || "", email: profile.email || "", address: profile.address || "" });
  }, [profile]);

  const save = async () => {
    setSaving(true);
    try {
      const next = await profileService.update(form);
      setProfile(next);
      toast(tx("บันทึกข้อมูลเรียบร้อย", "Profile saved"), "success");
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Card>
        <div className="u-center">
          <Avatar name={profile?.fullname || profile?.email} size="lg" />
          <div className="u-strong u-fs-18 u-mt-8">{profile?.fullname || profile?.email}</div>
          <div className="u-fs-13 u-muted">{profile?.email}</div>
        </div>
      </Card>

      <Card title={tx("ข้อมูลส่วนตัว", "Personal information")}>
        <Input label={tx("ชื่อ-นามสกุล", "Full name")} value={form.fullname} onChange={(e) => setForm({ ...form, fullname: e.target.value })} />
        <PhoneInput label={t("common.phone")} value={form.phone} onChange={(value) => setForm({ ...form, phone: value })} />
        <Input label={t("common.email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <Input label={tx("ที่อยู่จัดส่งพัสดุ", "Shipping address")} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
        <Button variant="primary" block onClick={save} disabled={saving}>
          {saving ? tx("กำลังบันทึก...", "Saving...") : t("action.save")}
        </Button>
      </Card>
    </>
  );
}
